import { createApi } from '@reduxjs/toolkit/query/react'
import { API_ENDPOINTS } from 'Constants'
import { bobFmsUrlQuery } from 'Services/baseQuery'

export const bobFmsApi = createApi({
  reducerPath: 'bobFmsUrlQuery',
  baseQuery: bobFmsUrlQuery,
  endpoints: (builder) => ({
    downloadFile: builder.query<
      string,
      {
        file_id: string
        preview: 'True' | 'False'
      }
    >({
      query: (params) => ({
        url: '/',
        method: 'GET',
        params: params,
        responseType: 'arraybuffer',
        // headers: {
        //   'content-type': 'application/pdf',
        // },
      }),
    }),
  }),
})

export const { useLazyDownloadFileQuery } = bobFmsApi
